import { Component, Input, OnInit } from '@angular/core';
import {BsModalRef} from "ngx-bootstrap/modal";
import { PermissionsService } from 'src/app/services/permissions/permissions.service';

@Component({
  selector: 'app-nps-help-modal',
  templateUrl: './nps-help-modal.component.pug',
  styleUrls: ['./nps-help-modal.component.scss'],
  standalone: false
})
export class NpsHelpModalComponent implements OnInit {

  @Input() request;

  constructor(public _bsModalRef: BsModalRef, public permissionService: PermissionsService) {}

  ngOnInit(): void {
  }

  close() {
    this._bsModalRef.hide();
  }
}
